// extracted by mini-css-extract-plugin
export var button = "EndCta-module--button--AHLpp";
export var enterFromBottom = "EndCta-module--enterFromBottom--8u1hx";
export var hidden = "EndCta-module--hidden--WLKj2";
export var inner = "EndCta-module--inner--IXsUZ";
export var leaveToTop = "EndCta-module--leaveToTop--iJ70R";
export var text = "EndCta-module--text--mXFBE";
export var word = "EndCta-module--word--kk3Rw";
export var wrapper = "EndCta-module--wrapper--XoshB";